import Button from 'components/common/Button';
import Colors from 'assets/Colors';
import { Col, Row } from 'antd';
import CustomDatePickerSelect from 'components/common/CustomDatePickerSelect';
import { useTranslation } from 'react-i18next';
import SelectProfileCustomer from './SelectState';
import s from '../../../styles/TopMenu.styles';

function TopMenu() {
  const { t } = useTranslation();
  return (
    <s.Container
      style={{
        width: '100%',
      }}
    >
      <s.LeftContainer>
        <Row>
          <Col flex={3} style={{}}>
            <Row>
              <Col>
                <s.Title>
                  {t('components.Reservation.TopMenu.reservationList')}
                </s.Title>
                <div style={{ display: 'flex' }}>
                  <SelectProfileCustomer />
                  <CustomDatePickerSelect />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </s.LeftContainer>

      <s.RightContainer>
        <Button
          type="primary"
          style={{
            background: Colors.primary,
            color: Colors.text_on_secondary,
            width: 'none',
            fontWeight: '500',
            border: 'none',
            height: '40px',
            marginTop: '12px',
          }}
        >
          {t('components.Reservation.TopMenu.newReservation')}
        </Button>
      </s.RightContainer>
    </s.Container>
  );
}

export default TopMenu;
